import { useAuth } from "react-oidc-context";

import type { ActiveIdp } from "shell/api/types";

import { IdpDiscoveryContent } from "common-services/features/shared/IdpDiscoveryContent";
import { useIdpDiscovery } from "common-services/hooks/useIdpDiscovery";
import { ThemeProvider } from "design-system/components/ThemeProvider";

export const IdpDiscovery = () => {
  const { signinRedirect } = useAuth();
  const { state, lookupDomain, reset } = useIdpDiscovery();

  const handleIdpSelect = (idp: ActiveIdp) => {
    signinRedirect({
      extraQueryParams: { identity_provider: idp.cognitoProviderName },
    });
  };

  const handleDefaultLogin = () => {
    signinRedirect({
      extraQueryParams: { identity_provider: "COGNITO" },
    });
  };

  return (
    <ThemeProvider>
      <IdpDiscoveryContent
        state={state}
        onEmailSubmit={lookupDomain}
        onReset={reset}
        onIdpSelect={handleIdpSelect}
        onDefaultLogin={handleDefaultLogin}
        testId="idp-discovery"
      />
    </ThemeProvider>
  );
};
